import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { toReturnUrlParam } from '@shared/utils/return-url.util';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  // Redirect to login with return url. `state.url` is the URL being *attempted*, so it is
  // already the right value here (unlike `Router.url`, which is still `/` mid-navigation —
  // see `redirectToLogin` in auth.interceptor.ts). Validated only so that no path in the
  // app can emit a `returnUrl` the picker would have to reject on the way back.
  const returnUrl = toReturnUrlParam(state.url);
  return router.createUrlTree(['/login'], {
    queryParams: returnUrl ? { returnUrl } : {},
  });
};

export const guestGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  // Redirect authenticated users to dashboard
  return router.createUrlTree(['/wallet']);
};
